let CONFIG={
  guoan: {
    titleIcon: 'logo.ico',//角标
    title: '国安人工智能系统',//标题
    loginLogo: require("@/assets/img/updateImg/logo.svg"),//登录logo
    scheduleIcon1: require('@/assets/img/logoIcon.png'),//赛程双方图标--国安
    scheduleIcon2: require('@/assets/img/reportImg/Calendar.svg'),//赛程双方图标--对手
  },
  demo: {
    titleIcon: 'faviconAcme.ico',//角标
    title: 'ACME人工智能系统',//标题
    loginLogo: require("@/assets/img/demoImg/demo_logo.svg"),//登录logo、
    scheduleIcon1: require('@/assets/img/demoImg/team1.svg'),//赛程双方图标--acme
    scheduleIcon2: require('@/assets/img/demoImg/team2.svg'),//赛程双方图标--对手
  }
}

export default {
  CONFIG
}
